
import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import NavBar from "../componenets/navbar/NavBar";
import Dashboard from "../componenets/dashboard/Dashboard";
import { ToastContainer } from 'react-toastify';
import { showToast } from "../componenets/utils/Function/Helper";

const Home = () =>{
    const navActive = useSelector((state) => state.navActive.value);
    useEffect(() => {
        const bodypd = document.getElementById('cbody');
        (navActive) ?  bodypd.classList.add('body-pd') : bodypd.classList.remove('body-pd');
    }, [navActive]);

    useEffect(() => {
        const loginSuccess = localStorage.getItem('loginSuccess');
        if (loginSuccess) {
            showToast("success", loginSuccess);
            localStorage.removeItem('loginSuccess');
        }
      }, []);
  
    return(<>
        <NavBar />
        <ToastContainer />
        <div id="cbody" className="cbody">
            <Dashboard/>
        </div>
    </>);
};

export default Home;
